import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import HappyHourScreen from './happyHour';
import ChaufaScreen from './chaufa';
import CevicheScreen from './ceviche';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import DetailProduct from './DetailProduct';
import translate from '../../helpers/translate';
import HotDrinksScreen from './hotdrink';
import CoolDrinksScreen from './cooldrink';
import NaturalJuiceScreen from './narutalJuice';
import SaladsScreen from './salads';
import TacosScreen from './tacos';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showDetailProduct, setShowDetailProduct] = useState(false);
        const [dataDish, setDataDish] = useState(false); 
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [visibleMenu, setvisibleMenu] = useState(true);
    const [dataapptizers, setdataapptizers] = useState(false);
    const [dataOysters, setdataOysters] = useState(false);
    const [fatherdata, setfatherdata] = useState(false);
    const [showChaufa, setShowChaufa] = useState(false);
    const [showCeviche, setShowCeviche] = useState(false);
    const [showHotDrinks, setShowHotDrinks] = useState(false);
    const [showCoolDrinks, setShowCoolDrinks] = useState(false);    
    const [showNaturalJuice, setShowNaturalJuice] = useState(false);
    const [showSalads, setShowSalads] = useState(false);
    const [showTacos, setShowTacos] = useState(false);
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 252) {
                setdataapptizers(item.menus);
            }

            if (item.id === 631) {
                setfatherdata(item);
            }
        });
    }, [menus]);


    useEffect(() => {
        if (dataapptizers) {
            dataapptizers.map((item) => {
                if (item.id === 4985) {
                    setdataOysters(item);
                }
            });
        }
    }, [dataapptizers]);


   



    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setvisibleMenu(false);
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            getInitData();
            const scrollDiv = document.getElementById("mi-scroll-container");
            if (scrollDiv) {
                // reinicia la posición de scroll
                scrollDiv.scrollTop = 0;
            }

        } else if (document.visibilityState === "visible") {
            setvisibleMenu(true);
            const scrollDiv = document.getElementById("mi-scroll-container");
            if (scrollDiv) {
                // reinicia la posición de scroll
                scrollDiv.scrollTop = 0;
            }
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    

        window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    
    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false} showImageTop={false} setShowSpecials={setShowSpecials}>
                <div>
                    <div>
                        <center>
                             <img
                             onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: 720,
                                height: 150,
                                justifyContent: 'center',
                                objectFit: 'contain',
                                zIndex: 100,
                                alignSelf: 'center',
                                  pointerEvents: 'none',
                                marginTop: 0,
                                   marginBottom: 20,
                                
                            }}
                            src={require('./assets/franciscas-logo_White.png')}
                        />
                        </center>
                    </div>
                <div style={{display: 'flex', width: '100%', marginTop: 0, position: 'relative',zIndex: 100}}>
                     <div style={{ width: '50%' }}>
                            <video
                            loop autoPlay={true} muted 
                            src={require('./assets/bannerhome.mp4')}
                           
                                style={{
                                marginTop: 40,
                                width: 300,
                                height: 540,
                                objectFit: 'cover',
                                borderRadius: 14,
                                marginTop: 22,
                            }}
                        />

                    </div>
                    <div style={{ width: '50%', paddingLeft: 12 }}>
                            
                           
                        
                            {visibleMenu &&  <div  id="mi-scroll-container" style={{height: 550, marginTop: 20,overflow: 'scroll'} }>
                            <div
                                style={{
                                   
                                    display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                            }}>
                                {menus.map((item, key) => {
                                    if (item.id != 705 && item.id != 706 && item.id != 707 && item.id != 708 && item.id != 669 && item.id != 670 && item.id != 671 && item.id != 672 && item.id != 673 && item.id != 674 && item.id != 675 && item.id != 676 && item.id != 677) {
                                        return (
                                            <div
                                                onClick={() => {

                                                    if (item.id === 342) {
                                                        setShowHappy(true)
                                                    }
                                                    else if (item.id === 686) {
                                                        setShowChaufa(true)
                                                    }
                                                    else if (item.id === 685) {
                                                        setShowCeviche(true)
                                                    }
                                                    else if (item.id === 690) {
                                                        setShowHotDrinks(true)
                                                    }
                                                    else if (item.id === 689) {
                                                        setShowCoolDrinks(true)
                                                    }
                                                    else if (item.id === 691) {
                                                        setShowNaturalJuice(true)
                                                    }
                                                    else if (item.id === 711) {
                                                        setShowSalads(true)
                                                    }
                                                    else if (item.id === 688) {
                                                        setShowTacos(true)
                                                    }
                                                    else {
                                                        setShowListProduct(true)
                                                        setdishs(item)
                                                    }
                                                }}
                                                style={{
                                                    width: 165,
                                                    height: 50,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                    marginTop: 22,
                                                    borderRadius: 12,
                                                    border: '4px solid #D9D9D9',
                                                    background: '#FFFFFF',
                                                    cursor: 'pointer',
                                                  
                                                }}>
                                                <p
                                                    style={{
                                                    fontSize: 20,
                                                    color: '#5C5C5C',
                                                    textTransform: 'uppercase',
                                                    textAlign: 'center',
                                                    paddingInline: 15,
                                                    margin: 0,
                                                    fontFamily: 'Poltawski',
                                                    fontWeight: 800,
                                                    fontStyle: 'italic',
                                                    letterSpacing: 1,
                                                    textShadow: '0 1px 1px rgba(0,0,0,0.20)'
                                                }}>
                                                    { translate(i18n.language, item.language, item.name)}
                                                </p>
                                            
                                            </div>
                                        );
                                    }
                                })}
                                </div>
                                
                               
                            </div>}
                            

                            {/* <div
                                                onClick={() => {
                                                setShowHappy(true)
                                                    
                                                }}
                                                style={{
                                                    width: '100%',
                                                    height: 75,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                    marginTop: 22,
                                                    borderRadius: 999,
                                                    border: '4px solid #FFFFFF',
                                                    background: 'transparent',
                                                    cursor: 'pointer'
                                                }}>
                                                <p
                                                    style={{
                                                    fontSize: 20,
                                                    color: '#FFFFFF',
                                                    textTransform: 'uppercase',
                                                    textAlign: 'center',
                                                    paddingInline: 30,
                                                    margin: 0,
                                                    fontFamily: 'Poltawski',
                                                    fontWeight: 800,
                                                    fontStyle: 'italic',
                                                    letterSpacing: 1
                                                }}>
                                                  DRINKS
                                                </p>
                                            
                            </div> */}
                      
                        </div>
                </div>
               
            </div>

           

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
                {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
                {showChaufa && <ChaufaScreen setShowHappy={setShowChaufa} />}
                {showSalads && <SaladsScreen setShowHappy={setShowSalads} />}
                {showCeviche && <CevicheScreen setShowHappy={setShowCeviche} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
            {showBar && <BarScreen setShowBar={setShowBar} />}
            {showHotDrinks && <HotDrinksScreen setShowHappy={setShowHotDrinks} />}
            {showCoolDrinks && <CoolDrinksScreen setShowHappy={setShowCoolDrinks} />}
            {showNaturalJuice && <NaturalJuiceScreen setShowHappy={setShowNaturalJuice} />}
            {showTacos && <TacosScreen setShowHappy={setShowTacos} />}
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowDetailProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}
            
            
            </LayoutContent>
            </div>
    );
}

export default Index;